(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormSubCategoryDialogController', EventFormSubCategoryDialogController);

    EventFormSubCategoryDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'EventFormCategory', 'Principal', 'AlertService', 'EventFieldDefinition'];

    function EventFormSubCategoryDialogController($scope, $uibModalInstance, entity, EventFormCategory, Principal, AlertService, EventFieldDefinition) {
        var vm = this;

        vm.eventFormSubCategory = entity;
        vm.customFieldReadLony = true;
        vm.customFieldsConfig = {baseFields: {}, fields: [], rules: []};
        vm.baseFieldDefinitions = buildBaseFieldDefinitions();
        vm.fieldDefinitions = [];
        vm.fieldTypes = [
            {code: 'text', label: 'Texte'},
            {code: 'integer', label: 'Entier'},
            {code: 'decimal', label: 'Décimal'},
            {code: 'boolean', label: 'Booléen'},
            {code: 'list', label: 'Liste'},
            {code: 'satisfaction_smiley', label: 'Satisfaction smiley'},
            {code: 'ref_contrat', label: 'RefContrat'}
        ];
        vm.ruleTypes = ['REQUIRED_IF', 'MIN_IF', 'MAX_IF', 'VALUE_POSSIBLE_IF'];
        vm.conditionOperators = ['EQUALS', 'NOT_EQUALS', 'IN', 'NOT_IN', 'GREATER_THAN', 'GREATER_OR_EQUALS', 'LOWER_THAN', 'LOWER_OR_EQUALS', 'IS_TRUE', 'IS_FALSE', 'IS_BLANK', 'IS_NOT_BLANK'];
        vm.severities = ['ERROR', 'WARNING'];
        vm.showJsonEditor = false;

        vm.save = save;
        vm.clear = clear;
        vm.addField = addField;
        vm.removeField = removeField;
        vm.addRule = addRule;
        vm.removeRule = removeRule;
        vm.onReorder = onReorder;
        vm.onFieldDefinitionChange = onFieldDefinitionChange;
        vm.onFieldTypeChange = onFieldTypeChange;
        vm.requiresRuleValue = requiresRuleValue;
        vm.requiresRuleValues = requiresRuleValues;
        vm.conditionRequiresValue = conditionRequiresValue;
        vm.conditionRequiresValues = conditionRequiresValues;
        vm.getFieldReferenceOptions = getFieldReferenceOptions;
        vm.initCustomFields = initCustomFields;
        vm.updateCustomFieldsJson = updateCustomFieldsJson;
        vm.isListField = isListField;
        vm.isSmileyField = isSmileyField;
        vm.isDictionaryLinked = isDictionaryLinked;
        vm.toggleJsonEditor = toggleJsonEditor;
        vm.handleFormKeydown = handleFormKeydown;

        Principal.hasAuthority('ROLE_SUPER_ADMIN').then(function(result) {
            vm.customFieldReadLony = !result;
        });

        loadFieldDefinitions();

        if (entity && entity.$promise) {
            entity.$promise.then(function() {
                vm.initCustomFields();
            });
        } else {
            vm.initCustomFields();
        }

        function save() {
            var cfg = vm.customFieldsConfig;

            if (!cfg || !cfg.fields) {
                try {
                    cfg = angular.fromJson(vm.eventFormSubCategory.customFields);
                } catch (e) {
                    AlertService.error('Les champs personnalisés ne sont pas valides.');
                    vm.isSaving = false;
                    return;
                }
            }

            ensureBaseFieldsConfig(cfg);

            var fieldNames = {};
            for (var i = 0; i < cfg.fields.length; i++) {
                var field = cfg.fields[i];
                field.name = field.name || field.code;
                field.dictionaryFieldCode = field.dictionaryFieldCode || field.fieldCode;
                field.legacyNames = normalizeLegacyNames(field.legacyNames || field.legacyCodes);

                if (field.dictionaryFieldCode && !enforceDictionaryBinding(field)) {
                    AlertService.error('Le champ dictionnaire ' + field.dictionaryFieldCode + ' est introuvable.');
                    vm.isSaving = false;
                    return;
                }

                if (!field.label || field.label.trim().length === 0) {
                    AlertService.error('Un champ contient un libellé vide.');
                    vm.isSaving = false;
                    return;
                }
                if (!field.name || field.name.trim().length === 0) {
                    AlertService.error('Un champ contient un nom technique vide.');
                    vm.isSaving = false;
                    return;
                }
                if (!(field.name.indexOf('cf.') === 0 || field.name.indexOf('sf.') === 0)) {
                    AlertService.error('Le nom technique stocké doit commencer par cf. ou sf.');
                    vm.isSaving = false;
                    return;
                }
                if (!/^[a-z0-9_]+$/.test(field.name.replace('cf.', '').replace('sf.', ''))) {
                    AlertService.error('Le nom technique ' + field.name + ' est invalide. Utiliser uniquement des minuscules, chiffres ou underscores.');
                    vm.isSaving = false;
                    return;
                }
                if (!field.type || field.type.trim().length === 0) {
                    AlertService.error('Un champ contient un type vide.');
                    vm.isSaving = false;
                    return;
                }
                if (fieldNames[field.name]) {
                    AlertService.error('Le nom technique ' + field.name + ' est utilisé en double.');
                    vm.isSaving = false;
                    return;
                }
                fieldNames[field.name] = true;
            }

            for (var j = 0; j < (cfg.rules || []).length; j++) {
                var rule = cfg.rules[j];
                if (!rule.type || !rule.targetField || !rule.condition || !rule.condition.field || !rule.condition.operator) {
                    AlertService.error('Une règle conditionnelle est incomplète.');
                    vm.isSaving = false;
                    return;
                }
            }

            vm.updateCustomFieldsJson();

            if (vm.eventFormSubCategory.customFields && vm.eventFormSubCategory.customFields.length > 0) {
                try {
                    angular.fromJson(vm.eventFormSubCategory.customFields);
                } catch (e2) {
                    AlertService.error('La configuration JSON technique est invalide.');
                    vm.isSaving = false;
                    return;
                }
            }

            vm.isSaving = true;
            if (vm.eventFormSubCategory.id !== null) {
                EventFormCategory.updateSubCategory(vm.eventFormSubCategory, onSaveSuccess, onSaveError);
            } else {
                EventFormCategory.createSubCategory(vm.eventFormSubCategory, onSaveSuccess, onSaveError);
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addField() {
            vm.customFieldsConfig.fields.push({
                label: '',
                tooltip: '',
                name: '',
                dictionaryFieldCode: '',
                legacyNamesText: '',
                required: false,
                hidden: false,
                type: 'text',
                values: ''
            });
            vm.updateCustomFieldsJson();
            return false;
        }

        function removeField(index) {
            vm.customFieldsConfig.fields.splice(index, 1);
            vm.updateCustomFieldsJson();
        }

        function addRule() {
            vm.customFieldsConfig.rules.push({
                type: 'REQUIRED_IF',
                targetField: '',
                severity: 'ERROR',
                condition: {
                    field: '',
                    operator: 'EQUALS',
                    value: ''
                },
                value: '',
                valuesText: ''
            });
            vm.updateCustomFieldsJson();
        }

        function removeRule(index) {
            vm.customFieldsConfig.rules.splice(index, 1);
            vm.updateCustomFieldsJson();
        }

        function onReorder() {
            vm.updateCustomFieldsJson();
        }

        function onFieldDefinitionChange(field) {
            if (!field || !field.dictionaryFieldCode) {
                vm.updateCustomFieldsJson();
                return;
            }

            enforceDictionaryBinding(field);
            vm.updateCustomFieldsJson();
        }

        function onFieldTypeChange() {
            vm.updateCustomFieldsJson();
        }

        function requiresRuleValue(rule) {
            return rule && (rule.type === 'MIN_IF' || rule.type === 'MAX_IF');
        }

        function requiresRuleValues(rule) {
            return rule && rule.type === 'VALUE_POSSIBLE_IF';
        }

        function conditionRequiresValue(rule) {
            return rule && rule.condition && (rule.condition.operator === 'EQUALS' || rule.condition.operator === 'NOT_EQUALS'
                    || rule.condition.operator === 'GREATER_THAN' || rule.condition.operator === 'GREATER_OR_EQUALS'
                    || rule.condition.operator === 'LOWER_THAN' || rule.condition.operator === 'LOWER_OR_EQUALS');
        }

        function conditionRequiresValues(rule) {
            return rule && rule.condition && (rule.condition.operator === 'IN' || rule.condition.operator === 'NOT_IN');
        }

        function getFieldReferenceOptions() {
            var options = [];
            angular.forEach(vm.customFieldsConfig.fields || [], function(field) {
                var referenceCode = field.dictionaryFieldCode || field.name;
                if (!referenceCode) {
                    return;
                }
                options.push({
                    code: referenceCode,
                    label: (field.label || field.name || referenceCode) + ' (' + referenceCode + ')'
                });
            });
            return options;
        }

        function initCustomFields() {
            vm.customFieldsConfig = {baseFields: {}, fields: [], rules: []};

            if (vm.eventFormSubCategory.customFields) {
                try {
                    vm.customFieldsConfig = angular.fromJson(vm.eventFormSubCategory.customFields);
                } catch (e) {
                    console.warn('Invalid JSON in customFields');
                }
            }

            if (!vm.customFieldsConfig.fields) {
                vm.customFieldsConfig.fields = [];
            }
            ensureBaseFieldsConfig(vm.customFieldsConfig);
            if (!vm.customFieldsConfig.rules) {
                vm.customFieldsConfig.rules = [];
            }

            angular.forEach(vm.customFieldsConfig.fields, function(field) {
                field.name = field.name || field.code;
                field.dictionaryFieldCode = field.dictionaryFieldCode || field.fieldCode;
                field.legacyNamesText = normalizeLegacyNames(field.legacyNames || field.legacyCodes).join(';');
            });

            angular.forEach(vm.customFieldsConfig.rules, function(rule) {
                rule.severity = rule.severity || 'ERROR';
                rule.condition = rule.condition || {
                    field: '',
                    operator: 'EQUALS',
                    value: ''
                };
                rule.condition.operator = rule.condition.operator || 'EQUALS';
                if (angular.isArray(rule.values)) {
                    rule.valuesText = rule.values.join(';');
                }
                if (rule.condition && angular.isArray(rule.condition.values)) {
                    rule.condition.valuesText = rule.condition.values.join(';');
                }
            });

            refreshDictionaryBoundFields();
            vm.updateCustomFieldsJson();
        }

        function updateCustomFieldsJson() {
            var serializedFields = angular.copy(vm.customFieldsConfig.fields || []);
            angular.forEach(serializedFields, function(field) {
                field.name = field.name || field.code;
                field.dictionaryFieldCode = field.dictionaryFieldCode || field.fieldCode;
                field.legacyNames = normalizeLegacyNames(field.legacyNamesText || field.legacyNames || field.legacyCodes);
                delete field.code;
                delete field.fieldCode;
                delete field.legacyCodes;
                delete field.legacyNamesText;
            });

            var serializedRules = angular.copy(vm.customFieldsConfig.rules || []);
            angular.forEach(serializedRules, function(rule) {
                if (rule.valuesText) {
                    rule.values = splitValues(rule.valuesText);
                } else {
                    delete rule.values;
                }
                delete rule.valuesText;

                if (rule.condition && rule.condition.valuesText) {
                    rule.condition.values = splitValues(rule.condition.valuesText);
                } else if (rule.condition) {
                    delete rule.condition.values;
                }
                if (rule.condition) {
                    delete rule.condition.valuesText;
                }
            });

            var serializedBaseFields = angular.copy(ensureBaseFieldsConfig(vm.customFieldsConfig));
            angular.forEach(serializedBaseFields, function(baseFieldConfig) {
                baseFieldConfig.visible = !!baseFieldConfig.visible;
                baseFieldConfig.required = !!baseFieldConfig.visible && !!baseFieldConfig.required;
            });

            vm.eventFormSubCategory.customFields = JSON.stringify({
                baseFields: serializedBaseFields,
                fields: serializedFields,
                rules: serializedRules
            }, null, 2);
        }

        function isListField(field) {
            return !!field && field.type === 'list';
        }

        function isSmileyField(field) {
            return !!field && field.type === 'satisfaction_smiley';
        }

        function isDictionaryLinked(field) {
            return !!(field && field.dictionaryFieldCode);
        }

        function toggleJsonEditor() {
            vm.showJsonEditor = !vm.showJsonEditor;
        }

        function handleFormKeydown($event) {
            if (!$event || $event.keyCode !== 13) {
                return;
            }
            var tagName = $event.target && $event.target.tagName ? $event.target.tagName.toUpperCase() : '';
            if (tagName !== 'TEXTAREA') {
                $event.preventDefault();
            }
        }

        function loadFieldDefinitions() {
            EventFieldDefinition.query({
                inclInactive: false,
                page: 0,
                size: 2000,
                sort: ['fieldCode,asc']
            }, function(result) {
                vm.fieldDefinitions = result || [];
                refreshDictionaryBoundFields();
                vm.updateCustomFieldsJson();
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors du chargement du dictionnaire.');
            });
        }

        function refreshDictionaryBoundFields() {
            angular.forEach(vm.customFieldsConfig.fields || [], function(field) {
                enforceDictionaryBinding(field);
            });
        }

        function enforceDictionaryBinding(field) {
            if (!field || !field.dictionaryFieldCode) {
                return true;
            }

            var definition = findDefinition(field.dictionaryFieldCode);
            if (!definition) {
                return false;
            }

            var previousName = trimToNull(field.name);
            var forcedStorageName = buildStorageNameFromDictionaryCode(definition.fieldCode || field.dictionaryFieldCode);

            if (previousName && previousName !== forcedStorageName) {
                field.legacyNamesText = mergeLegacyNames(field.legacyNamesText, previousName).join(';');
            }

            field.name = forcedStorageName;
            field.type = definition.dataType || field.type || 'text';

            if (!field.label) {
                field.label = definition.label;
            }
            if (!field.tooltip) {
                field.tooltip = definition.description;
            }
            if (field.type === 'list' && !field.values && definition.valuePossibleJson) {
                try {
                    var values = angular.fromJson(definition.valuePossibleJson);
                    if (angular.isArray(values)) {
                        field.values = values.join(';');
                    }
                } catch (e) {
                    field.values = definition.valuePossibleJson;
                }
            }

            return true;
        }

        function findDefinition(fieldCode) {
            var definition = null;
            angular.forEach(vm.fieldDefinitions, function(item) {
                if (!definition && item.fieldCode === fieldCode) {
                    definition = item;
                }
            });
            return definition;
        }

        function buildStorageNameFromDictionaryCode(fieldCode) {
            var rawCode = trimToNull(fieldCode) || 'field';
            var prefix = 'cf.';

            if (rawCode.indexOf('cf.') === 0 || rawCode.indexOf('sf.') === 0) {
                prefix = rawCode.substring(0, 3);
                rawCode = rawCode.substring(3);
            } else if (rawCode.indexOf('cf_') === 0 || rawCode.indexOf('sf_') === 0) {
                prefix = rawCode.substring(0, 2) + '.';
                rawCode = rawCode.substring(3);
            }

            rawCode = rawCode
                .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
                .replace(/[^a-zA-Z0-9]+/g, '_')
                .replace(/_+/g, '_')
                .replace(/^_+|_+$/g, '')
                .toLowerCase();

            if (!rawCode) {
                rawCode = 'field';
            }

            return prefix + rawCode;
        }

        function mergeLegacyNames(source, nameToAdd) {
            var values = normalizeLegacyNames(source);
            var normalizedName = trimToNull(nameToAdd);
            if (normalizedName && values.indexOf(normalizedName) === -1) {
                values.push(normalizedName);
            }
            return values;
        }

        function normalizeLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value.filter(function(item) {
                    return !!trimToNull(item);
                }).map(function(item) {
                    return trimToNull(item);
                });
            }
            return splitValues(value);
        }

        function splitValues(value) {
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function trimToNull(value) {
            if (value === null || value === undefined) {
                return null;
            }
            value = String(value).trim();
            return value.length ? value : null;
        }

        function buildBaseFieldDefinitions() {
            return [
                {key: 'dateRecord', label: 'Date de l’événement', help: 'Champ de date principal du document.'},
                {key: 'title', label: 'Titre', help: 'Titre court affiché dans les listes et tableaux de bord.'},
                {key: 'comment', label: 'Commentaire', help: 'Zone de commentaire libre du document.'},
                {key: 'gps', label: 'Coordonnées GPS', help: 'Carte et coordonnées latitude / longitude du document.'}
            ];
        }

        function ensureBaseFieldsConfig(config) {
            if (!config.baseFields) {
                config.baseFields = {};
            }

            angular.forEach(defaultBaseFields(), function(defaultConfig, key) {
                if (!config.baseFields[key]) {
                    config.baseFields[key] = angular.copy(defaultConfig);
                } else {
                    config.baseFields[key].visible = config.baseFields[key].visible !== false;
                    config.baseFields[key].required = config.baseFields[key].required === true || !!defaultConfig.required && config.baseFields[key].required !== false;
                }
                if (!config.baseFields[key].visible) {
                    config.baseFields[key].required = false;
                }
            });

            return config.baseFields;
        }

        function defaultBaseFields() {
            return {
                dateRecord: {visible: true, required: true},
                title: {visible: true, required: true},
                comment: {visible: true, required: false},
                gps: {visible: true, required: false}
            };
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:EventFormSubCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            AlertService.error(error.data && error.data.message ? error.data.message : 'Erreur lors de l\'enregistrement du document.');
        }
    }
})();
